import { DeliveryRecipientForm } from '@features/delivery/components';
import { DeliveryModal } from '@features/delivery/components/DeliveryModal';
import { useDeliveryContext } from '@features/delivery/components/DeliveryModal/DeliveryContext';
import { TextArea } from '@radix-ui/themes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ShareDeliveryItem, SharePayload } from '../types';

export const ShareDialog = () => {
    const { t } = useTranslation('share');

    const { suggestedEmails, executeAction, isOpen } = useDeliveryContext<
        ShareDeliveryItem,
        SharePayload
    >();

    const [emails, setEmails] = useState<string[]>([]);
    const [msg, setMsg] = useState('');
    const [notify, setNotify] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setEmails([]);
            setMsg('');
            setNotify(false);
        }
    }, [isOpen]);

    const hasEmails = emails.length > 0;

    return (
        <DeliveryModal.Content<ShareDeliveryItem, SharePayload>
            title={t('title')}
            a11yDescription={t('a11yDescription')}
            successTitle={
                hasEmails ? t('success.titleEmail') : t('success.titleLink')
            }
            successDescription={
                hasEmails ? t('success.descEmail') : t('success.descLink')
            }
        >
            <DeliveryModal.InvalidCallout<ShareDeliveryItem, SharePayload>
                warningText={t('warnings.noProxy')}
            />

            <DeliveryRecipientForm
                emails={emails}
                onEmailsChange={setEmails}
                notifySender={notify}
                onNotifyChange={setNotify}
                suggestedEmails={suggestedEmails}
                labels={{
                    recipients: t('inputs.emails'),
                    notify: t('inputs.notify'),
                }}
            />

            <DeliveryModal.ItemList<ShareDeliveryItem, SharePayload>
                label={t('inputs.items')}
            />

            <TextArea
                placeholder={t('inputs.msg')}
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
            />

            <DeliveryModal.ActionSubmit<ShareDeliveryItem, SharePayload>
                label={hasEmails ? t('actions.send') : t('actions.generate')}
                processingLabel={t('actions.processing')}
                disabled={!hasEmails && !notify}
                onClick={() => executeAction({ emails, message: msg, notify })}
            />
        </DeliveryModal.Content>
    );
};
